export default __webpack_public_path__ + "static/media/q2_04.8f0a66fd.png";